import {download, get, post} from "@/utils/http"

export const _selectPages = params => get("/mChatQrCode/selectPages", params);
export const _get = params => get("/mChatQrCode/get", params);
export const _genQrCode = params => post("/mChatQrCode/genQrCode", params);
export const _updateStatus = params => get("/mChatQrCode/updateStatus", params);
export const _delete = params => get("/mChatQrCode/delete", params);
export const _download = params => download("/mChatQrCode/download", params);



